import { Button } from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";

const ReloadButton = () => {
	const { t } = useTranslation();

	const reloadPage = () => {
		window.location.reload();
	};

	return (
		<Button variant="primary" w="100%" key="reload" onClick={reloadPage}>
			{t("choice_try_again")}
		</Button>
	);
};

export default ReloadButton;
